<template lang="pug">
.appointment
  v-overlay(v-if="update", :value="overlay")
    v-progress-circular(indeterminate, size="64")
  v-card
    v-toolbar(color="primary", dark, flat)
      v-toolbar-title {{ update ? 'Actualizar' : 'Creación de' }} Citas Médica
    .alert(v-if="messages_error_request")
      v-alert(border="top", color="red lighten-2", dark)
        ul
          li(v-for="message in messages_error_request") {{ message }}
    v-card-text
      ValidationObserver(
        ref="observer_appointmnet_data",
        v-slot="{ validate, reset }"
      )
        v-form
          v-row
            v-col(cols="12", sm="12", md="4")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="Mascota"
              )
                v-autocomplete(
                  v-model="appointment.pet",
                  label="Mascota",
                  type="text",
                  :items="pets",
                  item-text="code",
                  item-value="id",
                  :error-messages="errors",
                  clearable,
                  required
                )
                  template(v-slot:item='data')
                    v-list-item-icon
                      v-chip(color="primary")
                        label.white--text {{ data.item.name }}
                    v-list-item-content
                      v-list-item-title(v-html='data.item.code')
            v-col(cols="12", sm="12", md="4")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="Fecha"
              )
                v-menu(
                  v-model="menu_date",
                  :close-on-content-click="false",
                  transition="scale-transition",
                  offset-y,
                  max-width="290px",
                  min-width="290px"
                )
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="dateFormatted",
                      label="Fecha",
                      clearable,
                      persistent-hint,
                      readonly,
                      v-on="on",
                      @click:clear="date = null"
                    )
                  v-date-picker(
                    v-model="date",
                    no-title,
                    @input="menu_date = false"
                  )
            v-col(cols="12", sm="12", md="4")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="Hora"
              )
                v-menu(
                  v-model="menu_time",
                  :close-on-content-click="false",
                  transition="scale-transition",
                  offset-y,
                  max-width="290px",
                  min-width="290px"
                )
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="timeFormatted",
                      label="Hora",
                      clearable,
                      persistent-hint,
                      readonly,
                      v-on="on",
                      @click:clear="time = null"
                    )
                  v-time-picker(
                    v-model="time",
                    ampm-in-title,
                    @input="menu_time = false"
                  )
          v-row
            v-col(cols="12", sm="12")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="Razones"
              )
                v-textarea(
                  v-model="appointment.reason",
                  label="Razones",
                  type="text",
                  :error-messages="errors",
                  clearable,
                  required
                )
    v-card-actions
      v-spacer
      v-btn(
        color="secondary",
        @click="createUpdateAppointment",
        :loading="loading",
        :disabled="loading"
      ) Guardar
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import utils from "@/resources/utils";
import appointmentAPI from "@/api/appointment";
import { required } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} No puede ser vacío"
});

export default {
  async created() {
    if (this.update) {
      const response = await appointmentAPI.getAppointment(
        this.id_appointment,
        this.auth_token
      );
      this.overlay = false;
      if (response.status) {
        this.appointment.reason = response.data.reason;
        this.appointment.pet = response.data.pet;
        this.date = response.data.date.split("T")[0];
        this.time = response.data.date.split("T")[1].split("-")[0];
      } else {
        this.$swal({
          icon: "warning",
          title: response.data
        });
      }
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    update: {
      type: Boolean,
      required: false,
      default: false
    },
    id_appointment: {
      type: Number | String,
      required: false,
      default: 0
    }
  },
  computed: {
    ...mapState({
      pets: state => state.pets.pet_without_pag,
      auth_token: state => state.auth.auth_token
    }),
    dateFormatted() {
      return this.date
        ? moment(this.date)
            .locale("es")
            .format("LL")
        : "";
    },
    timeFormatted() {
      return this.time ? this.time : "";
    }
  },
  data() {
    return {
      messages_error_request: null,
      loading: false,
      overlay: true,
      menu_date: false,
      menu_time: false,
      date: null,
      time: null,
      appointment: {
        pet: null,
        date: null,
        reason: null
      }
    };
  },
  methods: {
    async createUpdateAppointment() {
      this.messages_error_request = null;
      if (await this.$refs.observer_appointmnet_data.validate()) {
        this.loading = true;
        this.appointment.date = `${this.date} ${this.time}`;
        if (this.update) {
          const response = await appointmentAPI.updateAppointment(
            this.id_appointment,
            this.appointment,
            this.auth_token
          );
          response.status
            ? await this.getAppointments(this.update)
            : this.$swal({
                icon: "success",
                title: response.data
              });
        } else {
          const response = await appointmentAPI.createAppointment(
            this.appointment,
            this.auth_token
          );
          response.status
            ? await this.getAppointments(this.update)
            : this.$swal({
                icon: "warning",
                title: response.data
              });
        }
        this.loading = false;
      }
    },
    async getAppointments(action) {
      let title = "";
      action ? (title = "Actualizada") : (title = "Creada");
      this.$swal({
        title: `Cita Médica ${title}`,
        icon: "success"
      });
      await this.$store.dispatch("appointments/getAppointments", {
        token: this.auth_token,
        page: 1
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.alert {
  padding: 15px;
}
</style>
